<template>
  <el-dialog :title="isUpdate ? '编辑 - 银行卡' : '添加 - 银行卡'" :visible="visible" width="900px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item label="财务名称:" prop="finance_id">
            <el-select clearable filterable class="ele-block" v-model="form.finance_id" placeholder="请选择">
              <el-option v-for="item in financeList" :key="item.id" :value="item.id" :label="item.username" />
            </el-select>
          </el-form-item>
          <el-form-item label="银行名称:" prop="bank_name">
            <el-input clearable :maxlength="20" v-model.trim="form.bank_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="分行名称:">
            <el-input clearable :maxlength="20" v-model.trim="form.branch_name" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="收款名称:" prop="account_name">
            <el-input clearable :maxlength="20" v-model.trim="form.account_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="银行账号:" prop="account_number">
            <el-input clearable :maxlength="20" v-model.trim="form.account_number" placeholder="请输入" />
          </el-form-item>
          <el-form-item :label="isUpdate ? '实际余额:' : '初始余额:'" prop="sj_amount">
            <el-input clearable :maxlength="20" v-model.trim="form.sj_amount" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import recolumnFormMixin from './recolumn-form-mixin';

export default {
  name: 'RecolumnEditBank',
  mixins: [recolumnFormMixin],
  computed: {
    rules() {
      return {
        finance_id: [{ required: true, message: '请选择', trigger: 'change' }],
        bank_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        account_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        account_number: [{ required: true, message: '请输入', trigger: 'blur' }],
        sj_amount: [{ required: true, message: '请输入', trigger: 'blur' }],
      };
    },
  },
  methods: {
    handleSave() {
      this.save(this.buildPayload({ qr_image: '', qr_code: '' }));
    },
  },
};
</script>
